module.exports = __webpack_public_path__ + "static/project-6a-b33d8458fc9017732d9d97f51c932702.png";